import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "col-12" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_MetricTitle = _resolveComponent("MetricTitle")!
  const _component_FilterTabs = _resolveComponent("FilterTabs")!
  const _component_LineChart = _resolveComponent("LineChart")!
  const _component_MetricSource = _resolveComponent("MetricSource")!
  const _component_SectionTitle = _resolveComponent("SectionTitle")!
  const _component_MetricStat = _resolveComponent("MetricStat")!
  const _component_MetricHighlight = _resolveComponent("MetricHighlight")!
  const _component_MetricGrid = _resolveComponent("MetricGrid")!

  return (_ctx.selectedData.length == 0)
    ? (_openBlock(), _createBlock(_component_Spinner, { key: 0 }))
    : (_openBlock(), _createBlock(_component_MetricGrid, { key: 1 }, {
        "metric-title": _withCtx(() => [
          _createVNode(_component_MetricTitle, {
            title: _ctx.metric.metric
          }, null, 8, ["title"])
        ]),
        filterTabs: _withCtx(() => [
          _createVNode(_component_FilterTabs, {
            options: _ctx.filterOptions,
            onHandleClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleFilter($event)))
          }, null, 8, ["options"])
        ]),
        chart: _withCtx(() => [
          _createVNode(_component_LineChart, {
            metricData: _ctx.selectedData,
            dataLabels: _ctx.dataLabels,
            dataProps: _ctx.dataProps,
            options: _ctx.options,
            dateLabel: _ctx.metric.dateProp
          }, null, 8, ["metricData", "dataLabels", "dataProps", "options", "dateLabel"]),
          _createVNode(_component_MetricSource, {
            metric: _ctx.metric,
            href: _ctx.sourceUrl()
          }, null, 8, ["metric", "href"])
        ]),
        summaryTitle: _withCtx(() => [
          _createVNode(_component_SectionTitle, {
            title: _ctx.summaryTitle()
          }, null, 8, ["title"])
        ]),
        metricStats: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_MetricStat, {
              label: "Employment",
              value: _ctx.latestNumbers,
              featured: true
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_MetricStat, {
              label: "Yearly Change",
              value: _ctx.yearChange
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_MetricStat, {
              label: "Yearly % Change",
              value: _ctx.yearChangePercent + '%'
            }, null, 8, ["value"])
          ])
        ]),
        "metric-highlight": _withCtx(() => [
          _createVNode(_component_MetricHighlight, { content: _ctx.highlight }, null, 8, ["content"])
        ]),
        _: 1
      }))
}